import { apiClient } from './client';
import type {
  ApiResponse,
  User,
  UserStats,
  Transaction,
  Subscription,
  Plan,
  ReferralStats,
} from '@/types';

export const api = {
  // User endpoints - WALLET-BASED AUTH
  user: {
    getMe: (wallet: string, tgId?: string, username?: string, firstName?: string) => {
      let url = `/user/me?wallet=${wallet}`;
      if (tgId) url += `&tgId=${tgId}`;
      if (username) url += `&username=${encodeURIComponent(username)}`;
      if (firstName) url += `&firstName=${encodeURIComponent(firstName)}`;
      return apiClient.get<ApiResponse<User>>(url);
    },
    getStats: (wallet: string) => apiClient.get<ApiResponse<UserStats>>(`/user/stats?wallet=${wallet}`),
    getBalance: (wallet: string) => apiClient.get<ApiResponse<{ balance: number }>>(`/user/balance?wallet=${wallet}`),
    linkReferrer: (wallet: string, referrerTgId: string) =>
      apiClient.post<ApiResponse<{ success: boolean; message: string }>>('/user/link-referrer', {
        wallet,
        referrerTgId
      }),
    activateTrial: (wallet: string) =>
      apiClient.post<ApiResponse<Subscription>>('/user/activate-trial', { wallet }, 90000), // 90 секунд для создания AmneziaWG
  },

  // Billing endpoints - WALLET-BASED AUTH
  billing: {
    getTreasury: () => apiClient.get<ApiResponse<{ walletAddress: string }>>('/billing/treasury'),
    getTransactionHistory: (wallet: string, limit = 20) =>
      apiClient.get<ApiResponse<Transaction[]>>(`/billing/transactions?wallet=${wallet}&limit=${limit}`),
  },

  // Subscription endpoints - WALLET-BASED AUTH
  subscriptions: {
    getPlans: () => apiClient.get<ApiResponse<Plan[]>>('/subscriptions/plans'),
    getActive: (wallet: string, noCache: boolean = false) =>
      apiClient.get<ApiResponse<Subscription | null>>(`/subscriptions/active?wallet=${wallet}`, undefined, noCache),
    purchase: (wallet: string, planId: string) =>
      apiClient.post<ApiResponse<Subscription>>('/subscriptions/purchase', { walletAddress: wallet, planId }, 30000),
    getStats: (wallet: string, subscriptionId: number) =>
      apiClient.get<ApiResponse<any>>(`/subscriptions/${subscriptionId}/stats?wallet=${wallet}`),
    sendAmneziaConfig: async (wallet: string, subscriptionId: number, configNumber: number = 1) => {
      return apiClient.post<ApiResponse<{ success: boolean; message: string }>>(
        `/subscriptions/${subscriptionId}/send-amnezia-config?wallet=${encodeURIComponent(wallet)}`,
        { configNumber }
      );
    },
  },

  // Referral endpoints - WALLET-BASED AUTH
  referral: {
    getStats: (wallet: string) => apiClient.get<ApiResponse<ReferralStats>>(`/referral/stats?wallet=${wallet}`),
    getTopReferrers: (limit = 10) =>
      apiClient.get<ApiResponse<any[]>>(`/referral/top?limit=${limit}`),
  },
};

export default api;
